<template>
  <div>
    <!-- MOBILE SIDEBAR -->
    <nav class="navbar navbar-dark navbar-theme-primary px-4 col-12 d-md-none829" style="background-color: #ffffff!important;z-index:99;padding: 10px;position: fixed;top: 71px;">
       <div class="d-flex align-items-center"></div>
       <div v-if="!propsdata[0].sidebar_mobile" class="d-flex align-items-center"><div @click="$emit('togglesidebar')" style="font-size: 20px;background: #2a354f;border-radius: 4px;padding: 0 4px 0 4px;"><span class="navbar-toggler-icon"></span></div></div>
       <div v-else class="d-flex align-items-center"><div @click="$emit('togglesidebar')" style="font-size: 20px;"><i class="fas fa-times" style="color: #2a354f;font-size:1.5em;"></i></div></div>
    </nav>
    <!-- DESKTOP SIDEBAR -->
    <nav v-show="propsdata[0].sidebar_mobile" id="sidebarMenu" class="sidebar d-md-block829 bg-dark text-white" style="background-color: #ffffff!important;border-right: 1px solid #dde1ed!important;display: none;">
       <div class="sidebar-inner px-4 pt-3">
          <div class="user-card d-flex align-items-center justify-content-between justify-content-md-center pb-5">
             <div class="collapse-close" style="position: absolute; right: 20px; top: 15px; font-size: 25px;"><a href="#sidebarMenu" class="fas fa-times" style="color: rgb(255, 255, 255) !important;"></a></div>
          </div>
          <ul style="margin-top:62px;" class="nav flex-column mt-endesktop sidebar-top-mobile">
             <p style="margin-left: 11px;margin-bottom: 0.8rem;font-weight: 900;color: #2a354f;font-size: 15px;"><i class="fa-solid fa-icons" style="margin-right: 7px;"></i>Logos
               <span v-show="propsdata[0].paid !== 'yes' && propsdata[0].cargado" style="display:none;float: right;"><span class="badge badge-md bg-success ms-1" style="display: block;color:#ffffff!important;">UPGRADE</span></span>
             </p>
             <li @click="$emit('togglesidebar')" class="nav-item">
               <router-link to="/dashboard/" active-class="selected" class="nav-link">
                 <i class="fa-solid fa-icons" style="margin-right:7px;"></i>
                 <span class="sidebar-text">My Logos</span>
               </router-link>
             </li>
             <li @click="$emit('togglesidebar')" class="nav-item" style="max-width: 100%;">
               <router-link to="/dashboard/bookmarked-logos" class="nav-link">
                 <i class="fa-solid fa-bookmark" style="margin-right:11px;"></i>
                 <span>Bookmarked Logos</span>
               </router-link>
             </li>
             <li @click="$emit('togglesidebar')" class="nav-item" style="max-width: 100%;">
               <router-link to="/dashboard/get-logo-files" class="nav-link" :class="{'router-link-active-manipulated': $route.path === '/dashboard/get-logo-files' || $route.path.startsWith('/dashboard/logo-files/') }">
                 <i class="fa-solid fa-paperclip" style="margin-right:9px;"></i>
                 <span>Logo Files</span>
               </router-link>
             </li>
             <li @click="$emit('togglesidebar')" class="nav-item" style="max-width: 100%;">
               <router-link to="/dashboard/get-profiles-and-covers" class="nav-link" :class="{'router-link-active-manipulated': $route.path === '/dashboard/get-profiles-and-covers' || $route.path.startsWith('/dashboard/profiles-and-covers/') }">
                 <i class="fa-solid fa-user-circle" style="margin-right:7px;"></i>
                 <span>Profiles and Covers</span>
               </router-link>
             </li>
             <li @click="$emit('togglesidebar')" class="nav-item" style="max-width: 100%;">
               <router-link to="/dashboard/business-cards" class="nav-link">
                 <i class="fa-regular fa-address-card" style="margin-right:5px;"></i>
                 <span>Business Cards</span>
               </router-link>
             </li>
             <li @click="$emit('togglesidebar')" class="nav-item" style="max-width: 100%;">
               <router-link to="/dashboard/email-signatures" class="nav-link">
                 <i class="fa-solid fa-signature" style="margin-right:3px;"></i>
                 <span>Email Signatures</span>
               </router-link>
             </li>
             <li @click="$emit('togglesidebar')" class="nav-item" style="max-width: 100%;">
               <router-link to="/dashboard/link-in-bio" class="nav-link">
                 <i class="fa-solid fa-mobile-screen-button" style="margin-right:11px;"></i>
                 <span>Link In Bio</span>
               </router-link>
             </li>
             <li @click="$emit('togglesidebar')" class="nav-item" style="max-width: 100%;">
               <router-link to="/dashboard/exclusive-deals" class="nav-link">
                 <i class="fa-solid fa-gift" style="margin-right:7px;"></i>
                 <span>Exclusive Deals</span>
               </router-link>
             </li>
             <li class="nav-item" style="height: 70px;display: flex;justify-content: center;">
              <a v-show="propsdata[0].paid !== 'yes' && propsdata[0].cargado" :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=dashboard_sidebar_button'" class="btn btn-md btn-pricing-plan animate-up-2" style="display:none;color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); border-color: #0a4ab4;position: fixed;bottom: 15px;width: 212px;">
               <svg width="24" height="24" fill="#f4bd00" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>
               Upgrade Now
              </a>
              </li>
          </ul>
       </div>
    </nav>

    <div v-show="propsdata[0].paid !== 'yes' && propsdata[0].cargado" class="nopagonav content2" style="position: relative;top: 68.5px;padding: 0;display:none;">
        <div style="color: #15a97c;background-color: rgb(255, 255, 255);border-color: #15a97c;width: 100%;display: inline-block;font-weight: 600;text-align: center;border: 0.0625rem solid;padding: 0.55rem 0.95rem;">Create & Download Unlimited Logos. <a :href="'/payment/sub/'+propsdata[0].unique_id+'?utm_campaign=dashboard_top_banner'" style="text-decoration: underline!important;color: #15a97c;font-weight: 600;">Upgrade Now</a>.</div>
    </div>

</div>
</template>

<style>
/* NAV ACTIVE */
.router-link-exact-active{
background: #f3f5f9;
color: #2a354f!important;
}
.router-link-exact-active:hover{
background: #f3f5f9;
color: #2a354f!important;
}
.router-link-active-manipulated{
background: #f3f5f9;
color: #2a354f!important;
}
.router-link-active-manipulated:hover{
background: #f3f5f9;
color: #2a354f!important;
}
#quesedeslice::-webkit-scrollbar {
    width: 5px;
}
#quesedeslice::-webkit-scrollbar-thumb {
    background: #ccc;
    border: 0 none #fff;
    border-radius: 50px;
}

#quesedeslice::-webkit-scrollbar-track {
    background: #e7e7e7;
    border: 0 none #fff;
    border-radius: 7px;
}
@media (max-width:767px) {
  .dropdown_folders{
    left: unset!important;
  }
}
[v-cloak] { display: none; };
</style>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  props:['propsdata'],
  data(){
    return {
    }
  },
  methods: {
},
mounted(){
},
// do not forget this section
directives: {
ClickOutside
}
};
</script>



// WEBPACK FOOTER //
// src/sidebar.vue